namespace Areas.Inventory {
    "use strict";

    export function copyRecord() {

        var dataGrid = $('#InventoryListGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inventory/List/CopyRecord/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }


    var tabItems = Areas.createTabsWithSameController("Inventory", ["Active", "Inactive"], "List");

    export function tabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }
}